/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDirectDebitPreferences} from '../api'

 export const useQueryGetDirectDebitPreferences = createReactQueryHook('getDirectDebitPreferences', getDirectDebitPreferences)
